export default "__VITE_ASSET__DBCWeEFk__"